import styled from '@emotion/styled';
import { brandGradient, globalAreaV2Sizes } from './styles';

const Bar = styled.div`
  height: ${globalAreaV2Sizes.gradientBarHeight};
  width: 100%;
  flex-shrink: 0;
  background: ${brandGradient};
`;

export function GradientBarV2() {
  return <Bar data-testid="gradient-bar-v2" />;
}
